/**
 * FlagIcon — minimalist SVG country flags rendered as small rounded pills.
 * Only the four countries used by the language picker are implemented. Each
 * flag is intentionally simplified (no coat of arms, no emblems) so it stays
 * crisp at 20 px and matches the app's clean design language.
 */
import React from "react";

const flags = {
  US: (
    <svg viewBox="0 0 24 16" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="16" fill="#B22234" />
      {[2, 4.5, 7, 9.5, 12, 14.5].map((y, i) => (
        <rect key={i} x="0" y={y} width="24" height="1.25" fill="#FFFFFF" />
      ))}
      <rect width="10" height="8" fill="#3C3B6E" />
      <g fill="#FFFFFF">
        {[1.2, 3.2, 5.2, 7.2].flatMap((x, xi) =>
          [1.2, 3.2, 5.2, 7.2].map((y, yi) => (
            <circle key={`${xi}-${yi}`} cx={x + (yi % 2) * 1} cy={y} r="0.4" />
          ))
        )}
      </g>
    </svg>
  ),
  ES: (
    <svg viewBox="0 0 24 16" xmlns="http://www.w3.org/2000/svg">
      <rect y="0" width="24" height="4" fill="#AA151B" />
      <rect y="4" width="24" height="8" fill="#F1BF00" />
      <rect y="12" width="24" height="4" fill="#AA151B" />
    </svg>
  ),
  FR: (
    <svg viewBox="0 0 24 16" xmlns="http://www.w3.org/2000/svg">
      <rect x="0" width="8" height="16" fill="#002395" />
      <rect x="8" width="8" height="16" fill="#FFFFFF" />
      <rect x="16" width="8" height="16" fill="#ED2939" />
    </svg>
  ),
  HT: (
    <svg viewBox="0 0 24 16" xmlns="http://www.w3.org/2000/svg">
      <rect y="0" width="24" height="8" fill="#00209F" />
      <rect y="8" width="24" height="8" fill="#D21034" />
    </svg>
  ),
};

export default function FlagIcon({ code, className = "" }) {
  const F = flags[code];
  if (!F) return null;
  return (
    <span
      className={`inline-flex items-center justify-center overflow-hidden rounded-[3px] ring-1 ring-black/10 shrink-0 ${className}`}
      style={{ width: "22px", height: "14px" }}
      aria-hidden="true"
    >
      {F}
    </span>
  );
}
